// src/store/searchStore.ts
import { create } from "zustand";
 
export interface SearchStore {
  selectedCity: string;
  searchLocality: string;
  setSelectedCity: (city: string) => void;
  setSearchLocality: (locality: string) => void;
}
 
export const useSearchStore = create<SearchStore>((set) => ({
  selectedCity: "Bengaluru", // default value
  searchLocality: "",
  setSelectedCity: (city: string) => {
    console.log("Zustand: updating selectedCity to", city);
    set({ selectedCity: city });
  },
  setSearchLocality: (locality: string) => {
    console.log("Zustand: updating searchLocality to", locality);
    set({ searchLocality: locality });
  },
}));
 
 